import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb37fc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Nuevo usuario", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-h5" }, "Añadir nueva comunidad de juego", -1))

import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { NewUserDTO } from "@/interfaces/Usuario";
import axios, { AxiosError } from "axios";
import ResponseNuevoUsuario from "../RegistroUsuarios/ResponseNuevoUsuario.vue";
import { getFacciones, registrarFaccion } from "@/services/FaccionesService";
import ModalMessageError from "../Commons/ModalMessageError.vue";
import { useUsuariosStore } from "@/store/usuarios";
import { FaccionDTO } from "@/interfaces/Faccion";
import ModalError from "../Commons/ModalError.vue";
import ErrorEmail from "./ErrorEmail.vue";
import ErrorNick from "./ErrorNick.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormRegistroUsuario',
  setup(__props) {

const usuariosStore = useUsuariosStore();

const nombre = ref("");
const primerApellido = ref("");
const segundoApellido = ref("");
const email = ref("");
const password = ref("");
const password2 = ref("");
const nick = ref("");
const ciudad = ref("");
const provincia = ref("");
const fechaNacimiento = ref("");
const router = useRouter();
const dialogNick = ref<boolean>(false);
const dialogEmail = ref<boolean>(false);
const dialogOk = ref(false);
const dialogDuplicado = ref(false);
const dialogAddFaccion = ref(false);
const loading = ref<boolean>(false);
const telefono = ref("");
const listaFacciones = ref<FaccionDTO[]>([]);
const nombreFacciones = ref<string[]>([]);
const faccionSelected = ref<string>("");
const nuevaFaccion = ref<string>("");
const idFaccionSelected = ref<number>();

const showErrorModal = ref<boolean>(false);
const provinciasEspaña = [
  "Álava", "Albacete", "Alicante", "Almería", "Asturias", "Ávila", "Badajoz", "Barcelona",
  "Burgos", "Cáceres", "Cádiz", "Cantabria", "Castellón", "Ceuta", "Ciudad Real", "Córdoba",
  "Cuenca", "Gerona", "Granada", "Guadalajara", "Guipúzcoa", "Huelva", "Huesca", "Islas Baleares",
  "Jaén", "La Coruña", "La Rioja", "Las Palmas", "León", "Lérida", "Lugo", "Madrid", "Málaga",
  "Melilla", "Murcia", "Navarra", "Orense", "Palencia", "Pontevedra", "Salamanca", "Santa Cruz de Tenerife",
  "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "Vizcaya",
  "Zamora", "Zaragoza"
];

const formatFecha = (fechaString: string) => {
  const fecha = new Date(fechaString);
  const year = fecha.getFullYear();
  const month = ("0" + (fecha.getMonth() + 1)).slice(-2);
  const day = ("0" + fecha.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};

const rules = {
  required: (value: string | null) => !!value || "Este campo es obligatorio.",
  email: (value: string | null) =>
    /.+@.+\..+/.test(value as string) || "Formato de correo inválido.",
  matchPassword: (value: string | null) =>
    value === password.value || "Las contraseñas no coinciden.",
  validDate: (value: string | null) => {
    const selectedDate = new Date(value as string);
    const currentDate = new Date();
    return (
      selectedDate < currentDate ||
      "La fecha debe ser menor que la fecha actual."
    );
  },
  phone: (value: string | null) =>
    /^\d{9}$/.test(value as string) ||
    "El número de teléfono debe tener 9 dígitos.",
};

const errors = reactive({
  nombre: false,
  primerApellido: false,
  email: false,
  password: false,
  password2: false,
  nick: false,
  ciudad: false,
  provincia: false,
  fechaNacimiento: false,
  telefono: false,
});

const loadFacciones = async () => {
  loading.value = true;
  try {
    const response = await getFacciones();
    listaFacciones.value = response.data;
    nombreFacciones.value = listaFacciones.value
      .map((f: { nombreFaccion: string }) => f.nombreFaccion)
      .sort();
  } catch (error) {
    console.error("Error al obtener las facciones:", error);
  } finally {
    loading.value = false;
  }
};

const openDialogNuevaFaccion = () => {
  dialogAddFaccion.value = true;
};

const addFaccion = async () => {
  loading.value = true;

  try {
    //Controlar que no duplique
    if (
      listaFacciones.value.find(
        (f) => f.nombreFaccion.toUpperCase() == nuevaFaccion.value.toUpperCase()
      )
    )
      dialogDuplicado.value = true;
    else {
      const response = await registrarFaccion(nuevaFaccion.value);
      if (!response.data) alert("Error del servidor");
    }

    dialogAddFaccion.value = false;
    loadFacciones();
  } catch (error) {
    console.error("Error al registrar una nueva facción:", error);
  } finally {
    loading.value = false;
    dialogAddFaccion.value = false;
    dialogDuplicado.value = true;
  }
};

const validateForm = () => {
  errors.nombre = !nombre.value;
  errors.primerApellido = !primerApellido.value;
  errors.email = !email.value || !rules.email(email.value);
  errors.password = !password.value;
  errors.password2 = !password2.value || password.value !== password2.value;
  errors.nick = !nick.value;
  errors.ciudad = !ciudad.value;
  errors.provincia= !provincia.value;
  errors.fechaNacimiento =
    !fechaNacimiento.value || !rules.validDate(fechaNacimiento.value);
  errors.telefono = !!telefono.value && !rules.phone(telefono.value);

  const formIsValid = Object.values(errors).every((error) => !error);

  if (formIsValid) {
    handlerNewUser();
  } else {
    alert("Por favor, completa todos los campos requeridos correctamente.");
  }
};

const handlerNewUser = async () => {
  dialogNick.value = false;
  dialogEmail.value = false;
  dialogOk.value = false;
  loading.value = true;

  const selectedFaccion = listaFacciones.value.find(
    (f) => f.nombreFaccion === faccionSelected.value
  );
  if (selectedFaccion) {
    idFaccionSelected.value = selectedFaccion.idFaccion;
  }

  const newUserDTO: NewUserDTO = {
    NombreUsuario: nombre.value,
    PrimerApellido: primerApellido.value,
    SegundoApellido: segundoApellido.value,
    Email: email.value,
    Contraseña: password.value,
    Rol: "JUGADOR",
    Nick: nick.value,
    nickLGDA: "",
    Ciudad: ciudad.value,
    Provincia: provincia.value,
    idFaccion: idFaccionSelected.value,
    FechaNacimiento: formatFecha(fechaNacimiento.value),
    Telefono: telefono.value,
  };
  try {
    await usuariosStore.postUser(newUserDTO);
    dialogOk.value = true;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<{ message: string }>;
      if (axiosError.response?.data?.message) {
        const message = axiosError.response.data.message;
        if (message === "El correo electrónico ya está en uso.") {
          dialogEmail.value = true;
        } else if (message === "El nick ya está en uso.") {
          dialogNick.value = true;
        }
      } else {
        router.push({ name: "error" });
      }
    } else {
      router.push({ name: "error" });
    }
  } finally {
    loading.value = false;
  }
};

const handleOkClick = () => {
  dialogOk.value = false;
  dialogEmail.value = false;
  dialogNick.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "login-form" }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        onSubmit: _withModifiers(validateForm, ["prevent"]),
                        ref: "form"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: nombre.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombre).value = $event)),
                            label: "Nombre",
                            type: "text",
                            required: "",
                            rules: [rules.required],
                            error: errors.nombre
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: primerApellido.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((primerApellido).value = $event)),
                            label: "Primer apellido",
                            type: "text",
                            required: "",
                            rules: [rules.required],
                            error: errors.primerApellido
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: segundoApellido.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((segundoApellido).value = $event)),
                            label: "Segundo apellido",
                            type: "text"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
                            label: "Correo electrónico",
                            type: "email",
                            rules: [rules.required, rules.email],
                            required: "",
                            error: errors.email
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: password.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
                            label: "Contraseña",
                            type: "password",
                            rules: [rules.required],
                            required: "",
                            error: errors.password
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: password2.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((password2).value = $event)),
                            label: "Repite contraseña",
                            type: "password",
                            rules: [rules.required, rules.matchPassword],
                            required: "",
                            error: errors.password2
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: nick.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((nick).value = $event)),
                            label: "Nick",
                            type: "text",
                            required: "",
                            rules: [rules.required],
                            error: errors.nick
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: ciudad.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ciudad).value = $event)),
                            label: "Ciudad",
                            type: "text",
                            required: "",
                            rules: [rules.required],
                            error: errors.ciudad
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_select, {
                            modelValue: provincia.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((provincia).value = $event)),
                            items: provinciasEspaña,
                            label: "Provincia",
                            required: "",
                            rules: [rules.required],
                            error: errors.provincia
                          }, null, 8, ["modelValue", "items", "rules", "error"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: telefono.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((telefono).value = $event)),
                            label: "Telefono",
                            type: "text",
                            rules: [rules.phone],
                            error: errors.telefono
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_combobox, {
                            modelValue: faccionSelected.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((faccionSelected).value = $event)),
                            items: nombreFacciones.value,
                            label: "Comunidad de juego",
                            onClick: loadFacciones
                          }, {
                            "append-item": _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "tonal",
                                color: "blue darken-1",
                                onClick: openDialogNuevaFaccion
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Añadir nueva comunidad ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: fechaNacimiento.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((fechaNacimiento).value = $event)),
                            label: "Fecha de Nacimiento",
                            type: "date",
                            rules: [rules.required, rules.validDate],
                            required: "",
                            error: errors.fechaNacimiento
                          }, null, 8, ["modelValue", "rules", "error"]),
                          _createVNode(_component_v_row, {
                            justify: "center",
                            class: "my-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                variant: "tonal",
                                color: "blue darken-1",
                                onClick: validateForm,
                                class: "mr-4"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Registrar ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                variant: "tonal",
                                color: "blue darken-1",
                                to: "inicio-sesion",
                                disabled: loading.value,
                                class: "mr-4"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Volver ")
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (loading.value)
                            ? (_openBlock(), _createBlock(_component_v_row, {
                                key: 0,
                                justify: "center",
                                class: "mt-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_progress_linear, {
                                    size: 24,
                                    width: 2,
                                    indeterminate: "",
                                    color: "primary",
                                    class: "progress-linear-margin"
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ModalError, {
        isVisible: showErrorModal.value,
        message: "Al menos un dato no es correcto. Revisa todos los campos.",
        "onUpdate:isVisible": _cache[12] || (_cache[12] = ($event: any) => (showErrorModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ErrorEmail, {
        isVisible: dialogEmail.value,
        "onUpdate:isVisible": _cache[13] || (_cache[13] = ($event: any) => (handleOkClick = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ErrorNick, {
        isVisible: dialogNick.value,
        "onUpdate:isVisible": _cache[14] || (_cache[14] = ($event: any) => (handleOkClick = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ResponseNuevoUsuario, {
        isVisible: dialogOk.value,
        "onUpdate:isVisible": _cache[15] || (_cache[15] = ($event: any) => (handleOkClick = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(ModalMessageError, {
        isVisible: dialogDuplicado.value,
        "onUpdate:isVisible": _cache[16] || (_cache[16] = ($event: any) => (dialogDuplicado.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(_component_v_dialog, {
        modelValue: dialogAddFaccion.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dialogAddFaccion).value = $event)),
        "max-width": "400px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, { ref: "addFaccionForm" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: nuevaFaccion.value,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((nuevaFaccion).value = $event)),
                        label: "Nombre de la comunidad",
                        required: "",
                        rules: [rules.required]
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "blue darken-1",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (dialogAddFaccion.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancelar ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "blue darken-1",
                    onClick: addFaccion
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Añadir ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})